/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import { G3W_FID, PAGELENGTHS, TIMEOUT }        from 'g3w-constants';
  import ApplicationState                         from 'store/application';
  import Component                                from 'g3w-component';
  import Field                                    from 'components/FieldG3W.vue';
  import DownloadFormats                          from 'components/QueryResultsActionDownloadFormats.vue';
  import GUI                                      from 'services/gui';
  import { VM }                                   from 'g3w-eventbus';
  import DataRouterService                        from 'services/data';
  import { throttle }                             from 'utils/throttle';
  import { debounce }                             from 'utils/debounce';
  import { getCatalogLayerById }                  from 'utils/getCatalogLayerById';
  import { createRelationsUrl }                   from 'utils/createRelationsUrl';
  import { getAlphanumericPropertiesFromFeature } from 'utils/getAlphanumericPropertiesFromFeature';
  import { saveBlob }                             from 'utils/saveBlob';

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'relation',

    props: {
      feature:           { default: null },
      relation:          {},
      previousview:      {},
      cardinality:       {},
      layer:             {},
      showrelationslist: { default: false},
      chartRelationIds:  { default: [] }
    },

    components: {
      Field,
      'downloadformats': DownloadFormats,
    },

    data() {
      const layer  = getCatalogLayerById(this.nmRelation ? this.nmRelation.referencedLayer : this.relation.referencingLayer);
      return {

        /** @since 4.0.0 */
        ApplicationState,

        /**
         * @since 4.0.0 chart state (action button)
         */
        chart: {
          toggled: false,
          button: !!this.chartRelationIds.find(id => id === this.relation.referencingLayer),
        },

        /**
         * @since 4.0.0 download state (action button)
         */
        download: {
          formats: layer.getDownloadableFormats().filter(f => 'pdf' !== f), // filter out pdf because already includes all features
          layer:   null,
          toggled: false,
          config:  { downloads: [] }
        },

        /**
         * @since 4.0.0 whether relation layer is editable
         */
        isEditable: layer.isEditable() && !layer.isInEditing(),

        /**
         * @since 3.11.2 table state
         */
        table: {
          title:         layer.getName() || layer.getTitle(),
          formStructure: layer.getLayerEditingFormStructure(),
          features:      [],
          //@TODO
          // Take in account code from 3.11 that check features attributes due settings of field visible
          /*const attrs = Object.keys(features[0] ? features[0].attributes : {});
          const cols  = layer.getTableHeaders().filter(h => attrs.includes(h.name));
          */
          columns:       layer.getTableHeaders(),
          rows:          [],
          rows_fid:      [],  
        },

        /**
         * @since 3.11.2
         */
        nmRelation: ApplicationState.project.getRelationById(this.relation.nmRelationId),

        /**
         * @since 4.0.0 whether to show table (inital request)
         */
        norelations: false,
      };
    },

    computed: {

      /**
       * @returns { number } count of available tools (editing icon, form structure, zoom to feature, ...)
       *
       * @since 3.9.0
       */
      showTools() {
        const isGeoLayer = (this.table.features || []).some(f => f.geometry);
        return [!!this.isEditable, !!this.table.formStructure, !!isGeoLayer].filter(Boolean).length;
      },

    },

    watch: {

      async norelations() {
        await this.$nextTick();
        this.resize();
      },
      
    },

    methods: {

     /**
      * @param { Object } geometry
      * @param geometry.type        Point, MultiPoint, etc ...
      * @param geometry.coordinates
      *
      * @since 3.9.0
      */
      zoomToGeometry(geometry) {
        if (geometry) {
          GUI
            .getService('map')
            .zoomToGeometry(new ol.geom[geometry.type](geometry.coordinates), { highlight: true });
        }
      },

      /**
       * @param opts
       * 
       * @returns DataTable pagination
       * 
       * @since 4.0.0
       */
      async getData(opts = {}) {
        try {
          GUI.setLoadingContent(true);
          GUI.disableContent(true);

          // get relations from server
          const response = await (await fetch(createRelationsUrl({
              layer:    this.layer,
              fid:      this.feature.attributes[G3W_FID],
              relation: this.relation,
            }), {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({
              page:      (opts.start ? opts.start/opts.length : 0) + 1, // get current page
              page_size: opts.length,
              formatter: 1,
              ordering:  opts.order.length ? `${'desc' === opts.order[0].dir ? '-' : ''}${this.table.columns[opts.order[0].column - Number(!!this.showTools)].name}` : undefined,
              field:     (this.table.columns || []).filter(c => ![null, undefined, ''].includes(c.search)).map(c => `${c.name}|ilike|${c.search}`).join('|AND,') || undefined,
            }),
          })).json();

          // extract features attributes
          let features = (response?.vector?.data?.features || []).map(f => ({
            id:         f.id,
            geometry:   f.geometry,
            attributes: Object.assign(f.properties, { [G3W_FID]: f.id }),
          }));

          // handle NM relations
          if (this.nmRelation && features.length) {
            features = (await DataRouterService.getData('search:features', {
              inputs: {
                layer:     getCatalogLayerById(this.nmRelation.referencedLayer),
                filter:    features.map(f => `${this.nmRelation.fieldRef.referencedField}|eq|${encodeURIComponent(f.attributes[this.nmRelation.fieldRef.referencingField])}`).join(`|OR,`),
                formatter: 1,
              },
              outputs: null
            })?.data?.[0]?.features || []).map(f => ({
              id:         f.getId(),
              geometry:   f.getGeometry(),
              attributes: getAlphanumericPropertiesFromFeature(f.getProperties()).reduce((props, p) => Object.assign(props, { [p]: f.get(p)}), {}),
            }));
          }

          this.table.features = features;
          this.table.rows     = features.map(f => [null].concat(this.table.columns.filter(h => h).map(h => { h.value = (f.attributes || f.properties)[h.name]; return h.value; })))
          this.table.rows_fid = features.map(r => r.attributes[G3W_FID]);

          return {
            data:            this.table.rows,
            recordsFiltered: response?.vector?.count ?? 0,
            recordsTotal:    response?.vector?.count ?? 0,
            filter:          features.map(f => f.id)
          };
        } catch(e) {
          console.warn(e);
          return {
            data:            [],
            recordsFiltered: 0,
            recordsTotal:    0,
          };
        } finally {
          // first request
          if (!this.table.get_data) {
            this.norelations = 0 === this.table.rows.length;
            this.table.get_data = true;
          }
          GUI.setLoadingContent(false);
          GUI.disableContent(false);
        }
      },

      /**
       * @returns { Promise<void> }
       */
      async resize() {
        // skip when ..
        if (!this.$refs.relation || 'none' === this.$refs.relation.parentNode.style.display) {
          return;
        }

        // in case of waiting table
        const table      = $(this.$refs.relation).find('div.dataTables_scrollBody');
        table.height(
          $(".content").height()
          - $('.query-relation  div.dataTables_scrollHeadInner').height()
          - $('.content_breadcrumb')                       .outerHeight()
          - $('.navbar')                                   .outerHeight()
          - $('.close-panel-block')                        .outerHeight()
          - $(this.$refs.header)                           .outerHeight()
          - $('.dataTables_filter').last()                 .outerHeight()
          - $('.dataTables_paginate.paging_simple_numbers').outerHeight()
          - $('.dataTables_scrollHead').last()             .outerHeight()
        );

        if (this.$table) {
          this.$table.columns.adjust();
        }
      },

      /**
       * @param type
       */
       async saveRelation(type) {
        ApplicationState.download = true;
        try {
          const response = await fetch(createRelationsUrl({
              layer:    this.layer,
              fid:      this.feature.attributes[G3W_FID],
              relation: this.relation,
              type
            }), {
            method:  'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Expose-Headers': 'Content-Disposition', // get filename from server
            },
            body: JSON.stringify({ formatter: 1 }),
            signal: AbortSignal.timeout(TIMEOUT),
          });

          if (!response?.ok) {
            throw (await response.json()).message;
          }

          saveBlob(await response.blob(), response.headers.get('content-disposition').split('filename=').at(-1));

          } catch(e) {
            console.warn(e);
            GUI.showUserMessage({
              type:     'alert',
              message:  e || 'info.server_error',
              closable: true,
            });
          }

          ApplicationState.download = false;
          this.download.toggled     = false;
      },

      /**
       * @param row
       * @param index
       */
      async showFormStructure(row, index) {
        GUI.showContent({
          content: new Component({
            internalComponent: new (Vue.extend({
              data: () => ({
                layerid:       this.table.layerId,
                feature:       this.table.features[index],
                fields:        this.table.columns.map((c, i) => Object.assign(c, { value: row[i], query: true, input: { type: `${require('gui/fields/fieldsservice').getType(c)}` } })),
                formStructure: this.table.formStructure,
              }),
              template: /* html */`
                <div class="queryresults-wrapper">
                  <div class ="queryresults-container">
                    <table ref="table" class="table">
                      <tbody>
                        <tr class="featurebox-body">
                          <td>
                            <tabs
                              :layerid = "layerid"
                              :feature = "feature"
                              :fields  = "fields"
                              :tabs    = "formStructure"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              `,
              async mounted() {
                await this.$nextTick();
                this.$refs.table.click();
              }
            }))
          }),
          push:       true,
          showgoback: true,
          closable:   false,
          title:      this.table.title,
        });
      },

      /**
       * @param index
       */
      editFeature(index) {
        GUI
          .getService('queryresults')
          .editFeature({
            layer: {
              id:         this.nmRelation ? this.nmRelation.referencedLayer : this.relation.referencingLayer,
              attributes: this.table.columns,
            },
            feature: this.table.features[index],
          });
      },

      /**
       * @FIXME add description
       */
      back() {
        this.$parent.setRelationsList();
      },

      onChartResize() {
        const move = e => {
          const perc                     =  (Math.abs(e.x -  window.innerWidth) * 100 / $(this.$refs.wrapper).width()); // percentage
          this.$refs.content.style.width = `${100 - perc}%`;
          this.$refs.chart.style.width   = `${perc}%`;
        };
        const el = document.getElementById('g3w-view-content');
        el.addEventListener('mousemove', move);
        el.addEventListener('mouseup', async () => { 
          el.removeEventListener('mousemove', move); 
          await this.$nextTick();
          GUI.emit('resize') 
        }, { once: true });
      },

    },

    created() {
      this.resize = debounce(this.resize.bind(this));
      GUI.on('resize', this.resize);
    },

    async mounted() {
      const layer = getCatalogLayerById(this.nmRelation ? this.nmRelation.referencedLayer : this.relation.referencingLayer);

      await this.$nextTick();

      this.relation.title = this.relation.name;

      /** @FIXME add description */
      if (this.download.formats.length) {
        this.download.layer = layer.state;
        this.download.config.downloads = this.download.formats.map(format => ({
          id: format,
          format,
          cbk: () => { this.saveRelation(layer.getDownloadUrl(format)); },
          download: true,
        }));
        this.download.handler = async () => {
          if (1 == this.download.formats.length) {
            this.saveRelation(layer.getDownloadUrl(this.download.formats[0]));
          } else {
            this.download.toggled = !this.download.toggled;
          }
          this.resize();
        };
      }

      VM.$on('reload-relations', () => { this.$table?.columns?.adjust(); });

      this.chart.handler = throttle(async () => {
        this.chart.toggled = !this.chart.toggled;
        await this.$nextTick();
        this.chart.container = this.chart.container ||  $('#chart_content');
        if (this.chart.toggled) {
          GUI.getService('queryresults').showChart([this.relation.referencingLayer], this.chart.container, { relations: [this.relation], fid: this.feature.attributes[G3W_FID] });
        } else {
          GUI.getService('queryresults').hideChart(this.chart.container)
        }
        this.resize();
      });
      
      if ('ONE' !== this.relation.type) {
        this.$table = $(this.$refs.table).DataTable({
          autoWidth:      false,
          bLengthChange:  true,
          dom:            'ltip',
          bSortCellsTop:  true,
          columnDefs:     [].concat(this.showTools ? { orderable: false, targets: 0, width: '1%' } : { orderable: true, targets: 0 }),
          order:          [],
          lengthMenu:     PAGELENGTHS,
          pageLength:     layer.getAttributeTablePageLength() || PAGELENGTHS[1],
          responsive:     true,
          scrollResize:   true,
          scrollCollapse: true,
          scrollX:        true,
          serverSide:     true,
          ajax: debounce(async (opts, cb) => {
            cb(await this.getData(opts));
            await this.$nextTick();
            // initial request
            if (this.norelations) {
              this.$table.destroy(true);
              this.$table = null;
            } else {
              this.$table.columns.adjust();
            }
          }),
        });

        this.changeColumn = debounce((e, i) => {
          const value = e.target.value.trim();
          this.table.columns[i].search = value;
          this.$table.columns(i).search(value).draw();
        });
      }

      // resize after popping child relation
      GUI.on('pop-content', () => setTimeout(() => this.resize()));

      // hide datatable rows → show only our custom "table_body"
      document.getElementById('table_body_attributes').remove();

      this.resize();
    },

    /**
     * @fires hide-chart
     */
    async beforeDestroy() {
      if (this.$table) {
        this.$table.destroy();
        this.$table = null;
      }
      //In case of chart open, need to hide chart
      if (this.chart.toggled) {
         GUI.getService('queryresults').hideChart(this.chart.container);
      }
      if (this.chart.container) {
        this.$emit('hide-chart', this.chart.container);
        this.chart.container = null;
      }
      //reset columns search attribute to reset search
      this.table.columns.forEach(c => delete c.search); 
      GUI.off('pop-content', this.resize);
      GUI.off('resize', this.resize);
    },

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"relation",staticClass:"query-relation",class:_vm.isMobile() ? 'mobile' : null},[_c('div',{ref:"header",staticClass:"header skin-background-color lighten"},[_c('div',{staticClass:"g3w-long-text"},[(_vm.showrelationslist)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right",value:('Back to relations'),expression:"'Back to relations'",arg:"right"}],staticClass:"action-button-icon action-button back-button",class:_vm.$fa('exit'),on:{"click":function($event){$event.stopPropagation();return _vm.back.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('b',{staticClass:"relation-tile skin-color"},[_vm._v(" "+_vm._s(_vm.relation.name)+" ")])]),_vm._v(" "),(_vm.table.rows.length)?_c('div',{staticClass:"relations-table-tools"},[(_vm.download.formats.length)?_c('span',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.ApplicationState.download),expression:"ApplicationState.download"},{name:"t-tooltip",rawName:"v-t-tooltip:left",value:(_vm.download.formats.length > 1 ? 'Downloads' : ("download_types." + (this.download.formats[0]))),expression:"download.formats.length > 1 ? 'Downloads' : `download_types.${this.download.formats[0]}`",arg:"left"}],staticClass:"action-button-icon action-button",class:[
          _vm.$fa('download'),
          { 'toggled-white': _vm.download.toggled } ],on:{"click":function($event){$event.stopPropagation();return _vm.download.handler.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),(_vm.chart.button)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom",value:('Show Chart'),expression:"'Show Chart'",arg:"bottom"}],staticClass:"action-button-icon action-button",class:[
          _vm.$fa('chart'),
          _vm.chart.toggled ? 'toggled-white' : '' ],on:{"click":function($event){$event.stopPropagation();return _vm.chart.handler.apply(null, arguments)}}}):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.norelations)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.table.get_data),expression:"!table.get_data"}],ref:"wrapper",staticClass:"relation-wrapper"},[_c('div',{ref:"content",style:({
        width:       _vm.chart.toggled ? '70%' : '100%',
        marginRight: _vm.chart.toggled ? '8px' : '3px',
        position:    'relative',
      }),attrs:{"id":"table_content"}},[(_vm.download.toggled)?_c('downloadformats',{staticClass:"header-component",attrs:{"layer":_vm.download.layer,"config":_vm.download.config}}):_vm._e(),_vm._v(" "),_c('table',{ref:"table",staticClass:"hover relationtable table table-striped row-border compact nowrap"},[_c('thead',[_c('tr',{staticStyle:{"height":"0! important"}},[(_vm.showTools)?_c('th',{style:({
                minWidth: _vm.showTools * 30 + 'px',
                padding:  '0 !important',
              })}):_vm._e(),_vm._v(" "),_vm._l((_vm.table.columns),function(c){return _c('th',[_vm._v(_vm._s(c.label))])})],2),_vm._v(" "),_c('tr',[(_vm.showTools)?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.table.columns),function(c,i){return _c('th',[_c('input',{staticClass:"form-control column-search",attrs:{"type":"text","placeholder":c.name,"title":'search by ' + c.name},domProps:{"value":c.search},on:{"keyup":function($event){return _vm.changeColumn($event, i)}}})])})],2)]),_vm._v(" "),_c('tbody',{attrs:{"id":"table_body_attributes","hidden":""}}),_vm._v(" "),_c('tbody',{ref:"table_body"},_vm._l((_vm.table.rows),function(row,index){return _c('tr',{key:_vm.table.rows_fid[index]},[(_vm.showTools)?_c('td',{staticClass:"table-tools"},[(_vm.table.features[index].geometry)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right",value:('Zoom to Geometry'),expression:"'Zoom to Geometry'",arg:"right"}],staticClass:"action-button row-form skin-color",class:_vm.$fa('marker'),on:{"click":function($event){$event.stopPropagation();return _vm.zoomToGeometry(_vm.table.features[index].geometry)}}}):_vm._e(),_vm._v(" "),(_vm.table.formStructure)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right",value:('Form View'),expression:"'Form View'",arg:"right"}],staticClass:"action-button row-form skin-color",class:_vm.$fa('table'),on:{"click":function($event){$event.stopPropagation();return _vm.showFormStructure(row, index)}}}):_vm._e(),_vm._v(" "),(_vm.isEditable)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right",value:('Edit'),expression:"'Edit'",arg:"right"}],staticClass:"action-button row-form skin-color",class:_vm.$fa('pencil'),on:{"click":function($event){$event.stopPropagation();return _vm.editFeature(index)}}}):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((row.slice(1)),function(value){return _c('td',[_c('field',{attrs:{"state":{value:value}}})],1)})],2)}),0)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chart.toggled),expression:"chart.toggled"}],staticClass:"skin-border-color lighten",staticStyle:{"border-style":"solid","border-width":"0 1px 0 1px","min-width":"5px","background-color":"#ddd","cursor":"col-resize"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.onChartResize.apply(null, arguments)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chart.toggled),expression:"chart.toggled"}],ref:"chart",style:({ width: _vm.chart.toggled ? '30%' : '0' }),attrs:{"id":"chart_content"}})]):_c('div',{staticClass:"dataTables_scrollBody"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('No relations found'),expression:"'No relations found'"}]})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-513f051c_0", { source: ".query-relation[data-v-513f051c]{margin-top:3px}.query-relation>.header[data-v-513f051c]{padding:3px;display:flex;justify-content:space-between;align-items:center;width:100%;margin:0!important}.query-relation>.header>.g3w-long-text[data-v-513f051c]{border-radius:3px;font-size:1.3em}.query-relation.mobile>.header>.g3w-long-text[data-v-513f051c]{font-size:1em}.relations-table-tools[data-v-513f051c]{font-size:1.1em;margin-bottom:3px}.relations-table-tools>.action-button[data-v-513f051c]{padding:5px}.relation-wrapper[data-v-513f051c]{display:flex;justify-content:space-between;margin-bottom:5px;margin-top:3px;height:95%}.back-button[data-v-513f051c]{font-size:.8em}.header-component[data-v-513f051c]{width:100%;display:flex;margin-left:auto;margin-bottom:5px;margin-right:4px}.relationtable .table-tools .action-button[data-v-513f051c]:hover{background-color:transparent}.relationtable.dataTable tbody tr.selected[data-v-513f051c]{background-color:#e4e4e4!important}.relationtable.dataTable tbody tr.selected .row-wrap-tabs .tabs-wrapper[data-v-513f051c]{background-color:#fff!important}#chart_content[data-v-513f051c]{padding-bottom:5px;margin-bottom:5px;margin-left:8px}.dataTables_scrollBody[data-v-513f051c]{font-weight:700;margin-top:10px;font-size:1.1em;display:flex;justify-content:space-between}.form-control.column-search[data-v-513f051c]{font-style:italic;font-weight:400}", map: undefined, media: undefined })
,inject("data-v-513f051c_1", { source: ".relation-wrapper .dataTables_length select{border:1px solid #ccc;background:#fff;height:27px}.relation-wrapper .paginate_button{background:0 0!important;color:currentColor!important;box-shadow:none!important}.relation-wrapper .paginate_button.disabled{opacity:.25!important}.relation-wrapper .dataTables_scroll{background:#fff}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-513f051c"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Relation.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__